import { ProgramDataHelper } from "@share/program/helpers/ProgramDataHelper";
import { ObserverMethods, Observers } from "@api/repositories/reatime-repository/types";
import { ObserversBase } from "@share/program/observers/ObserversBase";
import { AgendaUpdatedObserver } from "@share/program/observers/AgendaUpdatedObserver";
import { RealtimeRepository } from "@api/repositories/reatime-repository/RealtimeRepository";
import { AgendaLikesUpdatedObserver } from "@share/program/observers/AgendaLikesUpdatedObserver";
import { AgendaCommentsUpdatedObserver } from "@share/program/observers/AgendaCommentsUpdatedObserver";
import { EventLikesUpdatedObserver } from "@share/program/observers/EventLikesUpdatedObserver";

export class SignalRObserversHelper {
    /**
     * <schemaId, methods>
     */
    observers: Record<string, ObserverMethods> = {};

    constructor(
        private readonly repository: RealtimeRepository,
        private readonly programDataHelper: ProgramDataHelper
    ) {
        this.registerObservers(process.env.VUE_APP_AGENDA_SCHEMA || 'Agenda',  [
            new AgendaUpdatedObserver(programDataHelper),
            new AgendaLikesUpdatedObserver(programDataHelper),
            new AgendaCommentsUpdatedObserver(programDataHelper)
        ]);

        this.registerObservers(process.env.VUE_APP_EVENTS_SCHEMA || 'Events', [
           new EventLikesUpdatedObserver(programDataHelper)
        ]);
    }

    private registerObservers(schemaId: string, observers: ObserversBase[]) {
        for (let i = 0, len = observers.length; i < len; i++) {
            if (!this.observers[schemaId]) {
                this.observers[schemaId] = {};
            }

            this.observers[schemaId][observers[i].method] = observers[i].handler.bind(observers[i]);
        }
    }

    private getChannelForLanguage(lang: string, schemaId: string) {
        return `objects.${schemaId}.${lang}`;
    }

    private generateObservers(lang: string) {
        const observers: Observers = {};
        for (let [schemaId, observersList] of Object.entries(this.observers)) {
            observers[this.getChannelForLanguage(lang, schemaId)] = observersList;
        }

        return observers;
    }

    async connect(lang = 'en') {
        try {
            await this.repository.attach(this.generateObservers(lang));
        }
        catch (e) {
            await this.programDataHelper.store.dispatch('reportError', e);
        }
    }

    async disconnect(lang = 'en') {
        try {
            await this.repository.detach(this.generateObservers(lang));
        }
        catch (e) {
            await this.programDataHelper.store.dispatch('reportError', e);
        }
    }

}
